var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcTextField',{attrs:{"required":true,"label":_vm.t('mail', 'Flag'),"value":_vm.flag},on:{"update:value":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }